/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VehicleTypeListResponse } from '../../models/vehicle-type-list-response';

export interface GetVehicleTypes$Params {
}

export function getVehicleTypes(http: HttpClient, rootUrl: string, params?: GetVehicleTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<VehicleTypeListResponse>> {
  const rb = new RequestBuilder(rootUrl, getVehicleTypes.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VehicleTypeListResponse>;
    })
  );
}

getVehicleTypes.PATH = '/api/v1/vehicle_types';
